import { BrokeNotificationData } from '@/modules/client-setting/type'
import { ColumnDef } from '@tanstack/react-table'
import UpdateBrokeNotification from './CellAction/UpdateBrokeNotification'
import { IsActiveBrokeNotification } from './CellAction/IsActive'
import { BrokeNotificationModelType } from '@/schema'
import DeleteBrokeNotification from './CellAction/DeleteBrokeNotification'
import EditOrder from './CellAction/EditOrder'

// Enum type to Thai label mapping
export const TYPE_LABEL_MAP: Record<BrokeNotificationModelType, string> = {
	[BrokeNotificationModelType.RETURN_LOSS]: 'คืนยอดเสีย',
	[BrokeNotificationModelType.DAILY_CHECK_IN]: 'เช็คอินรายวัน',
	[BrokeNotificationModelType.LUCKY_WHEEL]: 'วงล้อนำโชค',
	[BrokeNotificationModelType.COMMISSION_CASHBACK]: 'คอมมิชชั่นคืนเงิน',
	[BrokeNotificationModelType.SHOP]: 'ร้านค้า',
	[BrokeNotificationModelType.DEPOSIT_PROMOTION]: 'โปรโมชั่นฝากเงิน',
	[BrokeNotificationModelType.COUPON]: 'คูปอง',
	[BrokeNotificationModelType.GO_DEPOSIT]: 'ฝากเงิน',
}

export const columns: ColumnDef<BrokeNotificationData>[] = [
	{
		accessorKey: 'order',
		header: 'ลำดับ',
	},
	{
		accessorKey: 'title',
		header: 'หัวข้อ',
	},
	{
		accessorKey: 'type',
		header: 'ประเภท',
		cell: ({ row }) => TYPE_LABEL_MAP[row.original.type] || row.original.type,
	},
	{
		accessorKey: 'isActive',
		header: 'สถานะ',
		cell: ({ row }) => <IsActiveBrokeNotification row={row.original} />,
	},
	{
		id: 'editOrder',
		header: 'แก้ไขลำดับ',
		cell: ({ row }) => <EditOrder row={row.original} />,
	},
	{
		id: 'action',
		header: 'จัดการ',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				<UpdateBrokeNotification data={row.original} />
				<DeleteBrokeNotification data={row.original} />
			</div>
		),
	},
]

export const writeAccessorKeys = ['isActive', 'editOrder', 'action']
